<template>
  <div class="loginpage">
    <main>
      <div  id="login-form" class="al-flex">
        <div id="login-panel" style="padding:42px">
          <div class="logo">
            <logo class="cursor-pointer" alt="Authorize Local Logo"/>
          </div>
          <div class="input-area">
            <input type="email" placeholder="Enter your email"
                   v-model="email"
                   @keyup.enter="reset">
            <div class="al-button" @click="reset">SEND RESET LINK</div>
          </div>
          <div class="login-options">
            <div class="signup">Already have an account? <a href="/login">Sign In!</a></div>
          </div>
        </div>
        <div class="credentials">© 2022 | <a href="https://authorizelocal.com">Authorize Local</a></div>
      </div>
    </main>
  </div>
</template>

<script>

import Logo from '../../layouts/components/Logo'
export default{
  data () {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false,
      inputIsVisible: false
    }
  },
  components: {
    Logo
  },
  mounted () {
  },
  methods: {
    emailClick () {
    },
    reset () {
      const reset_payload = {
        email: this.email
      }

      this.$store.dispatch('resetPassword', reset_payload)
        .then((response) => {
          console.log('success')

          this.$vs.notify({
            title: 'Successful',
            text: response.data.message,
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
          })
          this.$router.push('/')
        })
        .catch(error => {
          this.$vs.loading.close()
          console.log('error')
          console.log(error)
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })

          this.$router.push('/login')
        })
    }
  }
}
</script>

<style lang="scss">
</style>
